(() => {
  const validateTerms = () => {
    const checkbox = document.getElementById('SokamejaCartTerms');
    if (!checkbox) return false;
    const error = document.getElementById('SokamejaTermsError');
    if (error) error.hidden = checkbox.checked;
    checkbox.setAttribute('aria-invalid', String(!checkbox.checked));
    if (!checkbox.checked) checkbox.focus();
    return checkbox.checked;
  };

  document.addEventListener('change', (event) => {
    if (event.target.id !== 'SokamejaCartTerms') return;
    validateTerms();
  });

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const checkout = event.target.closest('[name="checkout"], a[href*="/checkout"]');
    if (!checkout) return;
    // Every ordinary storefront checkout path must pass through the full cart.
    if (!document.getElementById('SokamejaCartTerms')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(window.routes?.cart_url || '/cart');
    } else if (!validateTerms()) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('submit', (event) => {
    if (!(event.target instanceof HTMLFormElement)) return;
    if (event.submitter?.name !== 'checkout') return;
    if (!validateTerms()) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
})();
